import MailSearchStore from './schema/MailSearchStore';
import { ObservableMap } from 'mobx';
import { SuggestionSet } from 'owa-search-service';
import { createStore } from 'satcheljs';
import { getDefaultAdvancedSearchViewState } from './schema/AdvancedSearchViewState';

export const defaultMailSearchStore: MailSearchStore = {
    fromDate: null,
    includeAttachments: false,
    initialSearchScope: null,
    isSearchHistoryDirty: false,
    legacySuggestions: new ObservableMap<string, SuggestionSet>({}),
    previousNode: null,
    refinersVisible: false,
    searchNumber: 0,
    staticSearchScope: null,
    staticSearchScopeList: null,
    toDate: null,
    advancedSearchViewState: getDefaultAdvancedSearchViewState(),
    initialAdvancedSearchViewState: getDefaultAdvancedSearchViewState(),
};

const initialStore = { ...defaultMailSearchStore };
export const getStore = createStore<MailSearchStore>('mailSearchStore', initialStore);

const store = getStore();
export default store;
